import { Paths } from 'type-fest';

import { useConfiguration } from './useConfiguration';
import { RuntimeConfig } from './app-config.types';

export function useAsset(assetName: Paths<RuntimeConfig['assets']>): string {
  const assets = useConfiguration('assets');
  const asset = assets[assetName];

  if (!asset) {
    throw new Error(`Asset "${assetName}" not found in configuration.`);
  }

  return asset;
}
